import { render, staticRenderFns } from "./SingleStoragePage.vue?vue&type=template&id=73f32328&scoped=true&"
import script from "./SingleStoragePage.vue?vue&type=script&lang=js&"
export * from "./SingleStoragePage.vue?vue&type=script&lang=js&"
import style0 from "./SingleStoragePage.vue?vue&type=style&index=0&id=73f32328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f32328",
  null
  
)

export default component.exports